/**
 * @generated SignedSource<<48b4ca96322327e90090b3d78c141b47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShippingDetailsBuyerLocationForm_item$data = {
  readonly address: {
    readonly itemAddress: string | null;
  } | null;
  readonly " $fragmentType": "ShippingDetailsBuyerLocationForm_item";
};
export type ShippingDetailsBuyerLocationForm_item$key = {
  readonly " $data"?: ShippingDetailsBuyerLocationForm_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsBuyerLocationForm_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShippingDetailsBuyerLocationForm_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": "itemAddress",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f733ae1b131c81775c5e1b9513bfee7c";

export default node;
